export default __webpack_public_path__ + "static/homepage-emily-1c3aaa6c3737a6d92345e570040676b0.jpg";